import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import GenerateKeyForm from '@/views/login/loginComponents/OS/licenseUploadComponentsLinux/generateKeyForm.vue';
import { computed, inject, ref } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import UploadLicenseForm from '@/views/login/loginComponents/OS/licenseUploadComponentsLinux/uploadLicenseForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'licenseFirstLoginForm.linux',
  emits: ["loading"],
  setup(__props, { emit }: { emit: ({ (e: 'loading', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const showUploadLicense = ref(false);
const coordinatorsService = inject(IKCoordinatorsService);
const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const license = computed(() => GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license);

const goToUploadLicenseForm = async () => {
  showUploadLicense.value = true;
};
const goBack = () => {
  showUploadLicense.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_unref(license))
    ? (_openBlock(), _createBlock(IbxScopedCss, { key: 0 }, {
        default: _withCtx(() => [
          (showUploadLicense.value)
            ? (_openBlock(), _createBlock(UploadLicenseForm, {
                key: 0,
                onBackButton: goBack,
                onShowLoading: _cache[0] || (_cache[0] = (val) => emit('loading', val))
              }))
            : (_openBlock(), _createBlock(GenerateKeyForm, {
                key: 1,
                onGoToLicenseUpload: goToUploadLicenseForm
              }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})